import React, { useContext, useEffect, useState } from 'react';

import { Provider, ProviderFilters } from '../../app/models/Provider';
import { ServiceResponse } from '../../app/services/shared/interfaces';
import Breadcrumbs, { BreadcrumbsItem } from '../../template/MainTheme/components/Breadcrumbs';
import DefaultCard from '../../components/default/DefaultCard';
import useProviderService from '../../app/services/hooks/useProviderService';
import DefaultModal from '../../components/default/DefaultModal';
import DefaultToolBar from '../../components/default/DefaultToolBar';
import ButtonCreate from '../../components/buttons/ButtonCreate';
import useSweetAlert from '../../hooks/useSweetAlert';
import { toast } from 'react-toastify';
import ProviderCreate from './components/ProviderCreate';
import ProviderEdit from './components/ProviderEdit';
import ProviderDataTable from './components/ProviderDataTable';
import useReactConfirmAlert from '../../hooks/useReactConfirmAlert';
import { AppContext } from '../../contexts/AppContext';
import useNavigationPage from '../../hooks/useNavigationPage';

const breadcrumbs: BreadcrumbsItem[] = [
    {
        name: 'Proveedores',
        url: '/Providers',
        isActive: true
    }
];

const Providers = () => {

    const { navigationPage } = useNavigationPage();
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { fetchingGetProviders, getProviders, deleteProvider } = useProviderService();
    const [providers, setProviders] = useState<Provider[]>([]);
    const [totalRows, setTotalRows] = useState(0);

    const [providerIdEdit, setProviderIdEdit] = useState<number>(-1);
    const [showingEdit, setShowingEdit] = useState(false);
    const [showingCreate, setShowingCreate] = useState(false);
    

    const [filter, setFilter] = useState<ProviderFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'desc'
    });

    useEffect(() => {
        reloadTable();
    }, [filter]);

    const reloadTable = () => {
        getProviders(filter, {
            onSuccess: (response: ServiceResponse) => {
                setProviders(response.data.providers);
                setTotalRows(response.data.total_rows);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message, {
                    autoClose: 2000
                });

                if (response.data.to_dashboard) {
                    navigationPage('/')
                }
            }
        });
    };

    const showCreate = () => {
        setShowingCreate(true);
    };

    const hideCreate = () => {
        setShowingCreate(false);
    };

    const showEdit = (id: number) => {
        navigationPage(`/providers/${id}/edit`);
       
    };

    const showShow = (id: number) => {
        navigationPage(`/providers/${id}/show`)
       
    };

   
    const destroy = (ProviderId: number) => {
        const _text = 'Está a punto de eliminar el proveedor';

        useSweetAlert().requestConfirmation({
            title: '¿Estás seguro?',
            text: _text,
            confirmButtonText: 'Si, eliminar',
            cancelButtonText: 'Cancelar',
            onConfirm: () => {
                useSweetAlert().spinnerAlert('Eliminando proveedor...');
                deleteProvider(ProviderId, {
                    onSuccess: () => {
                        useSweetAlert().successAlert({
                            title: 'Éxito',
                            text: 'Se ha eliminado el proveedor'
                        });
                        reloadTable();
                    },
                    onError: () => {
                        useSweetAlert().errorAlert({
                            title: 'Error',
                            text: 'No se ha podido eliminar el proveedor'
                        });
                    }
                });
            },
            onCancel: () => {
                useSweetAlert().infoAlert({
                    title: 'Cancelado',
                    text: 'El proveedor no se ha eliminado'
                });
            }
        });

        // useReactConfirmAlert().requestConfirmation({
        //     title : '¿Estás seguro?',
        //     message :_text,
        //     buttons : {
        //         confirmButton:{
        //             'label' : 'Si, confirmar',
        //             onClick: () => {
        //                 if(showLoading)showLoading('loading', 'Eliminando proveedor...');
        //                 deleteProvider(ProviderId, {
        //                     onSuccess: (response: ServiceResponse) => {
        //                         if(hideLoading)hideLoading();

        //                         useReactConfirmAlert().successAlert({
        //                             title: 'Éxito',
        //                             message: response.message
        //                         });

        //                         reloadTable();
        //                     },
        //                     onError: (response: ServiceResponse) => {
        //                         if(hideLoading)hideLoading();

        //                         useReactConfirmAlert().errorAlert({
        //                             title: 'Error',
        //                             message: response.message
        //                         });
        //                     }
        //                 });
        //             },
        //         },
        //         cancelButton:{
        //             'label': 'No, cancelar',
        //             onClick: () => {

        //                 setTimeout(() => {
        //                     useReactConfirmAlert().infoAlert({
        //                         title: 'Cancelado',
        //                         message: 'El proveedor no se ha eliminado.'
        //                     });

        //                 }, 0);

        //             },
        //         },

        // }
        // })
    };

    return (
        <>
            <Breadcrumbs pageSection="Proveedores" breadcrumbs={breadcrumbs} />

            <DefaultCard>
                <DefaultToolBar
                    left={<ButtonCreate callbackCreate={showCreate} title="Nuevo proveedor" />}
                />

                <ProviderDataTable
                    providers={providers}
                    totalRows={totalRows}
                    loading={fetchingGetProviders}
                    edit={showEdit}
                    filter={filter}
                    setFilter={setFilter}
                />
            </DefaultCard>

            {showingCreate ? (
                <DefaultModal
                    show={showingCreate}
                    handleClose={hideCreate}
                    title="Crear proveedor"
                    backdrop={true}
                    showFooter={false}
                >
                    <ProviderCreate
                        onSaved={() => {
                            reloadTable();
                            hideCreate();
                        }}
                        onCancel={hideCreate}
                        onError={hideCreate}

                    />
                </DefaultModal>
            ) : null}

        </>
    );
};

export default Providers;
